/**
 * Reorder related content cards intro to top of post template.
 *
 * Moves the .cards-related-intro element to be the first child of
 * .wp-block-post-template for proper visual hierarchy.
 *
 * @since 1.0.0
 */
export function initCardsReorder() {
	// Find the intro section
	const cardsIntro = document.querySelector('.cards-related-intro');
	if (!cardsIntro) {
		return;
	}

	// Find the post template within the same container
	const postTemplate = cardsIntro.closest('.cards-related-inner')?.querySelector('.wp-block-post-template');
	if (!postTemplate) {
		return;
	}

	// Wrap the intro in an <li> if it's not already (ul elements must only contain li children)
	let introItem = cardsIntro;
	if (cardsIntro.tagName !== 'LI') {
		const li = document.createElement('li');
		cardsIntro.replaceWith(li);
		li.appendChild(cardsIntro);
		introItem = li;
	}

	// Move the intro to be the first child of the post template
	postTemplate.insertBefore(introItem, postTemplate.firstChild);
}
